import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CourierExtensionsComponent } from 'root/extensions/courier-extensions/courier-extensions.component';
import { CourierMatchersComponent } from 'root/extensions/courier-extensions/matchers/courier-matchers.component';
import { DocumentExtensionsComponent } from 'root/extensions/document-extensions/document-extensions.component';
import { SimpleExtensionsComponent } from 'root/extensions/simple-extensions/simple-extensions.component';
import { StateMatchersResolver } from './extensions-resolvers';

export { StateMatchersResolver } from './extensions-resolvers';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'couriers',
  },
  {
    path: 'couriers',
    component: CourierExtensionsComponent,
    data: { title: 'PAGE_TITLES.ROOT.couriers' },
  },
  {
    path: 'documents',
    component: DocumentExtensionsComponent,
    data: { title: 'PAGE_TITLES.ROOT.documents' },
  },
  {
    path: 'simple-extensions',
    component: SimpleExtensionsComponent,
    data: { title: 'PAGE_TITLES.ROOT.extensions' },
  },
  {
    path: 'courier/:courierId/state-matchers',
    component: CourierMatchersComponent,
    resolve: {
      matchers: StateMatchersResolver,
    },
    data: {
      templateType: 'parcel_status',
      title: 'PAGE_TITLES.ROOT.state_association',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExtensionsRoutingModule {

}
